import { FormattedMessage } from 'dibs-react-intl';

export const title = (
    <FormattedMessage id="pdpPricingGuidance.title" defaultMessage="Pricing Guidance" />
);

export const info = (
    <FormattedMessage
        id="pdpPricingGuidance.info"
        defaultMessage="We use creator, category, style, material, condition, color and item weight to determine item similarity. All sales and listings data is made anonymous."
    />
);

export const estimateTitle = (
    <FormattedMessage id="pdpPricingGuidance.estimateTitle" defaultMessage="1stDibs Estimate" />
);

export const estimateInfo = (
    <FormattedMessage
        id="pdpPricingGuidance.estimateInfo"
        defaultMessage="This estimate is generated using proprietary 1stDibs data models that analyze features of the item such as creator, material and time period. There is no guarantee the item will resell or appraise for this amount."
    />
);
